import { render, staticRenderFns } from "./VideoComponentHome.vue?vue&type=template&id=1626d652&scoped=true"
import script from "./VideoComponentHome.vue?vue&type=script&lang=js"
export * from "./VideoComponentHome.vue?vue&type=script&lang=js"
import style0 from "./VideoComponentHome.vue?vue&type=style&index=0&id=1626d652&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1626d652",
  null
  
)

export default component.exports